import {HttpEvent, HttpInterceptorFn} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import {catchError, EMPTY, Observable, throwError} from 'rxjs';
import { AuthHttpService } from 'app/services/auth.http.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const accessToken = localStorage.getItem('accessToken');
  const cloneReq = req.clone({
    headers: accessToken ? req.headers.set('Authorization', `Bearer ${accessToken}`) : req.headers,
  });
  return next(cloneReq).pipe(
    catchError((err) => {
      if (err.status === 401) {
        router.navigateByUrl('/auth');
        return EMPTY;
      }
      return throwError(() => err) as unknown as Observable<HttpEvent<any>>;
    })
  )
};
